<template>
  <UnopenedLeadCard @close="close" :lead="lead">    
    <div class="d-flex">
      <div 
        class="mt-5 rounded-lg px-4 py-3 d-flex align-center justify-center" 
        style="border: 1px solid #7D8E9B; width: 50%"
      >
        <div class="text-center">
          This lead costs {{ $formatters.formatCurrency(lead.price_cents) }} (+ tax).
        </div>
      </div>

      <div 
        class="mt-5 rounded-lg ml-2 px-4 py-3 d-flex elevation-2 align-center justify-center primary white--text"
        style="width: 50%" 
        @click="open"
      >
        <div class="text-center d-flex flex-column">
          <div style="font-size: 16px; font-weight: bold;">OPEN HERE</div>
        </div>
      </div>
    </div>

    <div class="mt-5">
      We're big on sharing the success. That's why <span class="blue--text text--darken-2">most
      of what we collect goes back to the person who sent this lead</span>. It's our way
      of making sure everyone wins!
    </div>
  </UnopenedLeadCard>
</template>

<script>
import UnopenedLeadCard from './UnopenedLeadCard.vue'

export default {
  name: 'UnopenedLeadSufficient',

  components: { UnopenedLeadCard },

  props: {
    lead: {
      type: Object,
      required: true,
    },
  },

  methods: {
    close() {
      this.$emit('close')
    },

    open() {
      this.$router.push( { name: 'leads', params: { lead_id: this.lead.lead_id }})
    },
  }
}
</script>